import React from "react";
import { IconName } from "../Icon/types";
import { CustomerStoryHighlight } from "./MeganavCustomerStories";
import { BlogPost } from "./MeganavBlog";
import G2BestMeetsRequirementsSpring2025 from "../images/badges/g2-best-meets-requirements-spring-2025.svg";
import G2BestResultsSpring2025 from "../images/badges/g2-best-results-spring-2025.svg";
import G2BestSupportSpring2025 from "../images/badges/g2-best-support-spring-2025.svg";
import { products } from "../ProductTile/data";
import FinLogoLight from "../Meganav/images/cust-logo-fin-light.svg";
import FinLogoDark from "../Meganav/images/cust-logo-fin-dark.svg";

export type FlyoutPanelList = {
  label: string;
  icon?: IconName;
  link: string;
  isMobile?: boolean;
  description?: string;
  badge?: string;
};

export type MenuItem = {
  name: string;
  link?: string;
  isHiddenMobile?: boolean;
  content?: React.ReactNode;
  panelClassName?: string;
};

export const productsMenu: FlyoutPanelList[] = [
  {
    label: "Architecture",
    icon: "icon-gui-squares-2-x-2-outline",
    link: "/platform",
  },
  {
    label: "Integrations",
    icon: "icon-gui-puzzle-piece-outline",
    link: "/docs/platform/integrations",
  },
  {
    label: "SDKs",
    icon: "icon-gui-cube-transparent-outline",
    link: "/docs/sdks",
  },
  {
    label: "Security & Compliance",
    icon: "icon-gui-shield-check-outline",
    link: "/security-and-compliance",
  },
];

export const compareMenu: FlyoutPanelList[] = [
  {
    label: "Ably vs Pusher",
    link: "/compare/ably-vs-pusher",
  },
  {
    label: "Ably vs PubNub",
    link: "/compare/ably-vs-pubnub",
  },
  {
    label: "Ably vs Socket.io",
    link: "/compare/ably-vs-socketio",
  },
];

export const solutionsMenu: FlyoutPanelList[] = [
  {
    label: "Fan Engagement",
    icon: "icon-gui-hand-thumb-up-outline",
    link: "/fan-engagement",
    description: "Enhance every moment with live, interactive fan experiences.",
  },
  {
    label: "FinTech",
    icon: "icon-gui-currency-dollar-outline",
    link: "/fin-tech",
    description:
      "Speed, reliability, and confidence in every user interaction.",
  },
  {
    label: "EdTech",
    icon: "icon-gui-academic-cap-outline",
    link: "/ed-tech",
    description: "Power collaborative, interactive learning environments.",
  },
  {
    label: "CXTech",
    icon: "icon-gui-face-smile-outline",
    link: "/cx-tech",
    description:
      "Deliver fast support, strong relationships, and high retention.",
  },

  {
    label: "HealthTech",
    icon: "icon-gui-heartbeat-outline",
    link: "/health-tech",
    description: "Reliable tools with full data privacy and compliance.",
  },
];

export const customerStoriesHighlight: CustomerStoryHighlight = {
  companyLogo: FinLogoLight,
  companyLogoDark: FinLogoDark,
  companyLink: "/case-studies/fin-intercom",
  companyName: "Fin",
  companyDesc:
    "drove 80% more efficiency in realtime delivery for AI chat by replacing its in-house realtime platform with Ably.",
};

export const companyMenu: FlyoutPanelList[] = [
  {
    label: "Our story",
    icon: "icon-gui-ably-badge",
    link: "/about",
  },
  {
    label: "Careers",
    icon: "icon-gui-briefcase-outline",
    link: "/careers",
    badge: "WE'RE HIRING",
  },
];

export const ablyAwards = [
  {
    image: G2BestSupportSpring2025,
    desc: "G2 Best Support Spring 2025",
  },
  {
    image: G2BestMeetsRequirementsSpring2025,
    desc: "G2 Best Meets Requirements Spring 2025",
  },
  {
    image: G2BestResultsSpring2025,
    desc: "G2 Best Results Spring 2025",
  },
];

export const menuItemLinks = [
  { name: "Pricing", link: "/pricing", isHiddenMobile: true },
  { name: "Docs", link: "/docs", isHiddenMobile: true },
];

export const defaultBlogPosts: BlogPost[] = [
  {
    title:
      "Ably AI Transport: keep your agents connected and stateful across devices",
    link: "/blog/ably-ai-transport",
    categories: [
      "New Release",
      "AI Transport",
      "New Feature",
      "RealTime Experiences",
      "Engineering",
      "Ably News",
    ],
    pubDate: "Dec 9, 2025",
  },
  {
    title:
      "Live chat at unlimited scale: What it takes to support stadium-sized audiences",
    link: "/blog/live-chat-at-unlimited-scale",
    categories: ["Chat"],
    pubDate: "Nov 18, 2025",
  },
];

export const productsForNav = {
  ...products,
  pubsub: { ...products.pubsub, link: "/pubsub" },
  liveSync: { ...products.liveSync, link: "/livesync" },
  chat: { ...products.chat, link: "/chat" },
  spaces: { ...products.spaces, link: "/spaces" },
  aiTransport: {
    ...products.aiTransport,
    link: "/ai-transport",
  },
  liveObjects: { ...products.liveObjects, link: "/liveobjects" },
};
